import { render, staticRenderFns } from "./AlertRuleCreateUpdate.vue?vue&type=template&id=05b94ba4&"
import script from "./AlertRuleCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./AlertRuleCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports